import { Container, Heading, Section, Text } from "@radix-ui/themes";
import { BaseConsultForm } from "~/components/BaseConsultForm";
import {
	Locale,
	type LocalizedStrings,
	useLocalization,
} from "~/components/localization/LocalizationProvider";

const localized: LocalizedStrings<{ title: string; introduction: string }> = {
	[Locale.EN]: {
		title: "Share a Smile With a Friend",
		introduction:
			"We’re so glad you love your smile enough to recommend us to a friend. Fill out the form below to refer a patient, and our team will follow up with you.",
	},
	[Locale.ES]: {
		title: "Comparte una sonrisa con un amigo",
		introduction:
			"Nos alegra que te guste tanto tu sonrisa que quieras recomendarnos a un amigo. Completa el formulario para referir a un paciente y nuestro equipo se pondrá en contacto contigo.",
	},
};

export function ReferralPage() {
	const text = useLocalization(localized);
	return (
		<Section px="5">
			<Container size="2">
				<Heading as="h1" mb="5">
					{text("title")}
				</Heading>
				<Text as="p" mb="6">
					{text("introduction")}
				</Text>
				<BaseConsultForm source="patients-refer-a-friend" />
			</Container>
		</Section>
	);
}
